import { render, staticRenderFns } from "./ShipmentTab.vue?vue&type=template&id=55fa7620&"
import script from "./ShipmentTab.vue?vue&type=script&lang=js&"
export * from "./ShipmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports